import { Checkbox, SelectMenu, Textbox } from 'components/generic';
import { useContext, Fragment, useRef, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { OnboardingContext } from 'providers/onboarding-provider';
import { getValuesById, emailValidationRegex, getValueById } from 'utils';
import classNames from 'classnames';
import Images from 'assets/Images';
import { cloneDeep } from 'lodash';

import './style.scss';

const SubDetails = () => {
	const context = useContext(OnboardingContext);
	const { createObj, setCreateObj } = context;
	const [emailValidation, setemailValidation] = useState();

	const referenceData = useSelector(state => state?.referenceData?.data);
	const inputfile = useRef();

	const statusIndex = useMemo(() => createObj?.op_formContent?.op_sectionList.findIndex(el => el?.op_sectionKey === createObj?.op_currentSection, [createObj]));

	// handle data fields
	const handleData = (e, i, j, type) => {
		Array.isArray(e) && createObj.op_formContent?.op_sectionList[statusIndex].op_subsections?.forEach(sval => sval.ss_key && (sval.ss_display = e.includes(sval.ss_key)));

		setCreateObj(prevState => {
			const data = cloneDeep(prevState);
			data.op_formContent.op_sectionList[statusIndex].op_subsections[i].ss_form[j].f_value = e;
			type === 'file' && (data.op_formContent.op_sectionList[statusIndex].op_subsections[i].ss_form[j]['f_displayName'] = e?.name);
			return data;
		});
		inputfile.current = null;
	};

	const handleAddMember = i => {
		setCreateObj(prevState => {
			const data = cloneDeep(prevState);
			data.op_formContent.op_sectionList[statusIndex].op_subsections[i].ss_display = true;
			data.op_formContent.op_sectionList[statusIndex]?.op_subsections[i]?.ss_form.push({
				f_key: 'c_addmeber' + (data.op_formContent.op_sectionList[statusIndex]?.op_subsections[i]?.ss_form.length + 1),
				f_type: 'textbox',
				f_label: '',
				f_value: '',
				f_placeholder: 'Enter',
				f_isMandatory: 'N'
			});
			return data;
		});
	};

	// Delete Members
	const handleDeleteMembers = (i, j) => {
		setCreateObj(prevState => {
			const data = cloneDeep(prevState);
			data?.op_formContent?.op_sectionList[statusIndex].op_subsections[i]?.ss_form.splice(j, 1);
			return data;
		});
	};

	const getValueMtpl = (array, id) => {
		const a = [];
		array?.map(el => {
			id?.map(e => {
				el?.key === e && a.push(el);
			});
		});
		return a;
	};

	const handlevalidation = value => {
		setemailValidation(!emailValidationRegex.test(value));
	};

	const fetchOnCountry = el => {
		const data = getValuesById(referenceData, el?.f_referenceValue)?.at()?.value;
		return data?.filter(e => e?.allowedCountries?.includes(createObj?.country));
	};

	const getDropdownOptions = el => {
		return ['c_paymentOptions']?.includes(el?.f_key) ? fetchOnCountry(el) : getValuesById(referenceData, el?.f_referenceValue)?.at()?.value;
	};

	const subsectionList = useMemo(() => {
		const currentSection = createObj?.op_formContent?.op_sectionList[statusIndex];
		return currentSection?.op_subsections?.map(
			(section, i) =>
				section?.ss_display && (
					<Fragment key={i}>
						{section?.ss_header && <h5>{section?.ss_header}</h5>}
						{section?.ss_text && <p className='sub-details__text'>{section?.ss_text}</p>}

						<div className={classNames({ row: section?.ss_key !== 'c_inviteMembers' })}>
							{section?.ss_form.map(
								(el, j) =>
									(el.f_type === 'textbox' && (
										<div key={j} className={classNames({ 'col-6': section.ss_key !== 'c_inviteMembers', 'sub-details__addmembers ': section.ss_key === 'c_inviteMembers' })}>
											<Textbox
												label={el?.f_label}
												placeholder={el?.f_placeholder}
												infoContent={el?.f_infoContent ? el?.f_infoContent : ''}
												mandatory={el?.f_isMandatory === 'Y' && !el?.f_disabled}
												onChange={e => handleData(e?.target?.value, i, j)}
												value={el?.f_value}
												disabled={el?.f_disabled}
												onBlur={() => el?.f_label.includes('Email') && handlevalidation(el?.f_value)}
												error={el?.f_label.includes('Email') && emailValidation && !el?.f_disabled}
												errorMessage={el?.f_label.includes('Email') && emailValidation && !el?.f_disabled ? 'The email format is not valid' : ''}
												type={(el?.f_label.includes('Email') && 'email') || (el?.f_label.includes('Phone') && 'number') || (el?.f_label.includes('Password') && 'password') || 'text'}
											/>
											{section.ss_key === 'c_inviteMembers' && <img src={Images.deleteGrey} alt='delete' onClick={() => handleDeleteMembers(i, j)} />}
										</div>
									)) ||
									(el.f_type === 'dropdown' && (
										<div className='col-6'>
											<SelectMenu
												label={el?.f_label}
												placeholder={el?.f_placeholder}
												infoContent={el?.f_infoContent ? el?.f_infoContent : ''}
												mandatory={el?.f_isMandatory === 'Y' && !el?.f_disabled}
												menuOptions={() => getDropdownOptions(el)}
												value={
													Array.isArray(el?.f_value)
														? getValueMtpl(getValuesById(referenceData, el?.f_referenceValue)?.at()?.value, el.f_value)
														: getValuesById(getValueById(referenceData, el?.f_referenceValue)?.value, el.f_value)
												}
												onChange={e => handleData(e, i, j)}
												disabled={el?.f_disabled}
												multiple={Array.isArray(el?.f_value)}
											/>
										</div>
									)) ||
									(el.f_type === 'upload' && (
										<div className='col-8 sub-details__attach'>
											<label>
												{el?.f_label} {el?.f_isMandatory === 'Y' && !el?.f_disabled && <sup>*</sup>}
											</label>
											<input ref={inputfile} type='file' id={el?.f_key} onChange={e => handleData(e?.target?.files[0], i, j, 'file')} />
											<span className='flex-start'>
												<img src={Images.attachment} />
												{el?.f_displayName || 'Attach Select'}
											</span>
										</div>
									)) ||
									(el.f_type === 'checkbox' && (
										<div className='col-6'>
											<Checkbox checked={el?.f_value === 'Y'} content={el?.f_label} onClick={e => handleData(e?.target?.checked ? 'Y' : 'N', i, j)} link={el?.f_link} />
										</div>
									))
							)}
							{section.ss_key === 'c_inviteMembers' && (
								<div className='sub-details__addmembers--button' onClick={() => handleAddMember(i)}>
									<img src={Images.add} alt='add' width='25px' height='25px' />
									<span>Add Member</span>
								</div>
							)}
						</div>
					</Fragment>
				)
		);
	}, [createObj, referenceData]);

	return (
		<>
			<div className='sub-details scroll-bar'>
				<h3>{createObj?.op_formContent?.op_sectionList[statusIndex]?.op_sectionValue}</h3>
				{subsectionList}
			</div>
		</>
	);
};

export default SubDetails;
